import type { FC } from 'react';
import type { GameListItemDto } from '@/queries/games/games.schema';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import GameCard from '@/components/entities/games/GameCard';
import GameSkeleton from '@/components/entities/games/GameCard/components/GameSkeleton';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { AppRoutes } from '@/i18n/constants';
import emptyStateImageBase from '@/public/assets/image/games/default/empty-favorites-games.webp';
import { GamesGrid } from './GameGrid';

interface GameListContentProps {
  isLoading: boolean;
  items?: GameListItemDto[];
  defaultPageSize: number;
  className?: string;
}
export const GameListContent: FC<GameListContentProps> = ({ isLoading, items, defaultPageSize, className }) => {
  const t = useTranslations('providers.game-list');

  const isMobile = useMediaQuery('(max-width: 768px)', { initializeWithValue: false });

  if (isLoading) {
    return (
      <GamesGrid className={className}>
        {Array.from({ length: defaultPageSize }).map((_, index) => (
          <GameSkeleton key={index} className="w-full h-full" showName={!isMobile} />
        ))}
      </GamesGrid>
    );
  }

  if (items && items.length > 0) {
    return (
      <GamesGrid className={className}>
        {items.map(game => (
          <GameCard
            key={game.id}
            {...game}
            id={game.id}
            showName={!isMobile}
            path={AppRoutes.gamesId(game.id)}
            className="justify-between h-full p-0"
            pictureClassName="w-full aspect-[155/207]"
          >
            {/* TODO: add rating when it will be available */}
            {/* {!isMobile &&  <RatingStars rating={0} size="sm" interactive maxRating={5} showValue className="mt-0.5" /> } */}
          </GameCard>
        ))}
      </GamesGrid>
    );
  }

  if (items) {
    return (
      <div className="flex flex-col items-center justify-center text-center py-20">
        <div className="flex flex-col items-center justify-center text-center relative max-lg:mt-10.25 lg:mt-10.25">
          <Image src={emptyStateImageBase} alt="Empty state" className="w-[13.6rem] h-auto pb-4.5 max-lg:ml-3.5 lg:ml-3" width={630} height={600} />
          <p className="text-white heading-h6 bottom-15 lg:bottom-20 mb-2.75">{t('empty-state-search-title')}</p>
        </div>
      </div>
    );
  }

  return null;
};
